module.exports = __webpack_public_path__ + "static/media/large-event-banner.801cc0f5.png";